import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {agregarEditarPrestamo, mostrarPrestamoById} from "../../redux/reducers/prestamosReducer";
import {
    Button,
    CircularProgress,
    FormControl,
    Grid,
    IconButton,
    Input,
    InputAdornment,
    InputLabel,
    TextField,
    Theme,
    Typography
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {moment, nullToEmptyString, sumarQuincena} from '../../helpers';
import SearchClienteDialog from '../../components/SearchClienteDialog';

import {AppBar, HtmlTooltip, LoadingProgress, MostrarError} from "../../components";
import {DateInput, TextFieldCurrency, TextFieldPhone} from "../../components/CustomTextField";
import Strings from "../../assets/strings";
import {SelectAgente, SelectCaja, SelectCartera, SelectDay, SelectEnum} from "../../components/selects";
import {AssessmentOutlined, CalculateOutlined, Close, Save} from "@mui/icons-material";
import AmortCal from "../../components/calAmort";
import Box from "@mui/material/Box";
import {useCustomFormInput} from "../../hooks/useCustomFormInput";
import {IPrestamoDetalle} from "../../redux/types/IPrestamo";
import {ConfCamposType} from "../../redux/types/ICompania";
import SelectUsoMultiples from "../../components/selects/SelectUsoMultiples";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {ICliente} from "../../redux/types/ICliente";
import {calcularTasa} from "../../services";

const useStyles = makeStyles((theme:Theme) => ({

  root: {
      padding: theme.spacing(2),
  },
    btn:{
        marginRight: 5,
        color:theme.palette.common.white,
        fontWeight:"normal",
    },
    btnCodeudor:{
        marginTop:theme.spacing(2),
        marginBottom:theme.spacing(2),
        boxShadow: "none !important",
        borderRadius: 0,
        background: theme.palette.grey[100],
        [theme.breakpoints.down('md')]: {
            width: "100%",
        },
    }

}));
let initialState:IPrestamoDetalle ={
    id: undefined,
    referencia: "",
    clienteId: undefined,
    carteraId:undefined,
    cliente:"",
    tipoAmortizacion: 1,
    capitalInicial: undefined,
    tasaInteres: undefined,
    montoCuota:undefined,
    plazo: undefined,
    ciclosPago: undefined,
    fecha: moment().format("YYYY-MM-DD"),
    fechaProximoPago: "",
    fechaPrimerPago:"",
    diasExcluidos: "",
    porcientoMora: undefined,
    porcientoComision:undefined,
    usuarioIdAgente:undefined,
    cajaId: undefined,
    gastosLegales:undefined,
    codeudor: "",
    codeudorCedula: "",
    codeudorTelefono: "",
    codeudorDireccion: "",
    prestamoIdReenganche: undefined,
    montoSeguro:undefined,
    inicial:undefined
};

export default function CrearPrestamo() {
    const classes = useStyles();
    let { preId:urlPreId} = useParams();
    const {state:urlState} = useLocation();
    const customFormInput = useCustomFormInput("prestamo") as ConfCamposType;
    const navigate = useNavigate();
    const location = useLocation();
    const [reenganche] = useState(Boolean(window.location.pathname.indexOf("reenganche") !== -1));
    const [state, setState] = useState(initialState);

    let dispatch = useAppDispatch();
    let {byId:prestamo,error, status} = useAppSelector(state => state.prestamos);
    let defaultCajId = useAppSelector(state => state.auth.user?.cajaIdDefault);
    let {porcientoMora=0} = useAppSelector(state => state.companias.data || {});


    //set cliente y caja por defecto
    useEffect(()=>{
        let obj = {}

        if(urlState?.cliente){
            const {clienteId,fullName } = urlState.cliente;
            obj = {
                cajaId: defaultCajId??undefined,
                clienteId,
                cliente: fullName,
            }
        }

        setState(prev=>({...prev, ...obj}));

    },[urlState,defaultCajId, setState])
    useEffect(()=>{
        if(urlPreId) dispatch(mostrarPrestamoById(+urlPreId));
    },[urlPreId,setState,dispatch]);
    useEffect(()=>{
        setState(prev=>({...prev, porcientoMora: porcientoMora}));
        if(urlPreId && prestamo?.id === parseInt(urlPreId)) {
            let preOjb = {...prestamo, montoCuota:undefined}
            if(reenganche){
                delete preOjb.id;
                delete preOjb.amortizacion;
                delete preOjb.pagos;
                delete preOjb.capitalInicial;
                preOjb.prestamoIdReenganche = prestamo.id
                preOjb.fecha = moment().format("YYYY-MM-DD")
            }
            setState(nullToEmptyString(preOjb));
        }
    },[urlPreId,prestamo,porcientoMora,reenganche]);

    // Reset fecha si se cambia a modalidad quincenal
    const {ciclosPago} = state
    useEffect(()=>{
        if(ciclosPago === 16){
            setState(prevState => ({...prevState,
                ciclosPago,
                fecha: "",
                fechaProximoPago: "",
                fechaPrimerPago:"",
            }));
        }

    },[ciclosPago]);
    const handleChange = (e:React.ChangeEvent<HTMLInputElement>) => {
        const {name,value} = e.target;
        if(name === "plazo"){
            return setState({...state,[name]: value? +value : undefined});

        } else if(!state.id && (name === "fecha" || name === "ciclosPago")){ //calcular fecha proximo pago
            const {fecha:preFecha,ciclosPago} = state;
            let cicloPago = name === "ciclosPago" ? parseInt(value) : ciclosPago;
            let fecha = moment(name === "fecha" ? value : preFecha,"YYYY-MM-DD");
            let fechaPrimerPago:string;

            if (cicloPago === 30) {
                fechaPrimerPago = fecha.add(1, "months").format("YYYY-MM-DD");
            }else if(cicloPago === 16){
                fechaPrimerPago = sumarQuincena(fecha) ? moment(sumarQuincena(fecha)).format("YYYY-MM-DD") : "";
            }else {
                fechaPrimerPago = fecha.add(cicloPago, "days").format("YYYY-MM-DD");
            }
            setState((prev)=>({...prev,[name]: value,fechaPrimerPago}));
        }else{
            setState({
                ...state,
                [name]: value,
            });
        }
    };
    const handleCliChange = (c: ICliente) => {
        setState({...state,clienteId:c.id,cliente:c.nombres+" "+c.apellidos});
    };

    const [fetchingTasa,setFetchingTasa] = useState(false);
    const getTasaInteres = () => {
        if(state.montoCuota && state.plazo && state.capitalInicial && state.tipoAmortizacion) {
            setFetchingTasa(true)
            calcularTasa({
                montoCuota: state.montoCuota ?? 0,
                plazo: +(state.plazo ?? 0),
                capital: +(state.capitalInicial ?? 0),
                tipoAmortizacion: +(state.tipoAmortizacion ?? 0)
            }).then(res => {
                setState(prev => ({...prev, tasaInteres: res.data}))
            }).finally(() => setFetchingTasa(false))
        }
    }
    const submit = (e:React.FormEvent<HTMLFormElement>) =>{
        e.preventDefault();
        let prestamo:IPrestamoDetalle = {...state,pagos:undefined,amortizacion:undefined,clienteAvatar:undefined};
        if(!!state?.montoCuota){
            setFetchingTasa(true)
            calcularTasa({
                montoCuota: state.montoCuota ?? 0,
                plazo: +(state.plazo ?? 0),
                capital: +(state.capitalInicial ?? 0),
                tipoAmortizacion: +(state.tipoAmortizacion ?? 0)
            }).then(({data}) => {
                setState(prevState => ({...prevState, tasaInteres: data}))
                dispatch(agregarEditarPrestamo({...prestamo, tasaInteres: +data}));
            }).finally(()=>setFetchingTasa(false))



        //     const {capitalInicial, tasaInteres, plazo, ciclosPago, tipoAmortizacion, fechaPrimerPago, montoCuota} = state;
        //
        //
        //     calcularTasa({
        //         montoCuota:montoCuota,
        //         plazo: +(plazo ?? 0),
        //         capital:  +(capitalInicial ?? 0)
        //     }).then(res=>{
        //         console.log(res)
        //     })
        //
        //     getAmortList({
        //         capital: capitalInicial,
        //         interes: tasaInteres,
        //         cuotas: plazo,
        //         ciclosPago: ciclosPago,
        //         tipoAmortizacian: tipoAmortizacion,
        //         fecha: fechaPrimerPago,
        //         montoCuota
        //     }).then(res=> {
        //         //setState(prevState => ({...prevState,tasaInteres: res.interes}))
        //         prestamo.tasaInteres = res.interes;
        //         console.log(res)
        //        // dispatch(agregarEditarPrestamo(prestamo));
        //     })
        }else {
            dispatch(agregarEditarPrestamo(prestamo));
        }
    };

    // const [calcularPorMenu, setCalcularPorMenu] = useState<Element|null>(null);
    // const [calcularPor, setCalcularPor] = useState<"interes"|"montoCuota">("interes");
    // const handleCalcularPor = (val:typeof calcularPor) => {
    //     setCalcularPorMenu(null)
    //     setCalcularPor(val)
    //     setState(prevState => ({...prevState, montoCuota:undefined, tasaInteres: undefined}))
    // }
    return (
        <>
            <AppBar title={(!!state.id ?Strings.editar :Strings.crear)+" "+(reenganche ? "Reenganche": Strings.prestamo)} backUrl={state.id?"/prestamo/"+state.id:undefined} />
            <div className={"contentInner "+classes.root}>
                {status === "loading" && <LoadingProgress vh/>}
                <MostrarError errors={error}/>

                <form onSubmit={submit} id="form1" autoComplete={"off"}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} lg={3}>
                            <SearchClienteDialog
                                required
                                value={state.clienteId}
                                cliente={state.cliente}
                                onChange={handleCliChange}
                                disabled={Boolean(state.id || state.prestamoIdReenganche)}
                            />
                        </Grid>
                    </Grid>
                    <br/>
                    <div className={"customCard"}>
                        <Typography color={"primary"} className={"title"}>DATOS DEL PRESTAMO</Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={6} sm={4} md={3}>
                                <SelectEnum value={state.tipoAmortizacion} name={"tipoAmortizacion"} label={Strings.amortizacion} required
                                            onChange={handleChange} group={"tiposAmortizacion"} />
                            </Grid>
                            <Grid item xs={6} sm={4} md={3}>
                                <SelectEnum value={state.ciclosPago} name={"ciclosPago"} label={Strings.modalidad} required
                                            onChange={handleChange} group={"ciclosPago"} />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextFieldCurrency
                                    name="capitalInicial"
                                    label={Strings.monto +" "+ (state.id ? Strings.prestado:Strings.aPrestar)}
                                    value={state.capitalInicial ?? ""}
                                    onChange={handleChange}
                                    disabled={Boolean(!!state.pagos?.filter(p=> !p.fechaAnulacion).length )}
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={6} sm={4} md={3} lg={3}>
                                <TextField
                                    name="plazo"
                                    label={"# "+Strings.cuotas}
                                    type="number"
                                    inputProps={{step:1,inputMode:"numeric"}}
                                    required
                                    value={state.plazo??""}
                                    fullWidth
                                    onChange={handleChange}
                                />
                            </Grid>
                            {/*<Grid item xs={6} sm={4} md={4} lg={3}>*/}
                            {/*    {calcularPor === "montoCuota" ?(*/}

                            {/*        <HtmlTooltip title={*/}
                            {/*            <em> {Strings.interesDesconocidoMsj}</em>*/}
                            {/*        } disableHoverListener>*/}
                            {/*            <div>*/}
                            {/*                <TextFieldCurrency*/}
                            {/*                    name="montoCuota"*/}
                            {/*                    required*/}
                            {/*                    value={state.montoCuota??""}*/}
                            {/*                    onChange={handleChange}*/}
                            {/*                    fullWidth*/}
                            {/*                    label={Strings.monto+" "+Strings.cuotas}*/}
                            {/*                    InputProps={{*/}
                            {/*                        endAdornment: (*/}
                            {/*                            <InputAdornment position="end">*/}
                            {/*                                <IconButton disabled={fetchingTasa} color={"primary"} onClick={(e)=>setCalcularPorMenu(e.currentTarget)} size="small">*/}
                            {/*                                    {fetchingTasa?<CircularProgress size={20} color="inherit"/>:<ArrowDropDown/>}*/}
                            {/*                                </IconButton>*/}
                            {/*                            </InputAdornment>*/}
                            {/*                        ),*/}
                            {/*                    }}*/}
                            {/*                    onKeyPress={(e:any) => {*/}
                            {/*                        if(e.key === 'Enter'){*/}
                            {/*                           e.preventDefault();*/}
                            {/*                            getTasaInteres()*/}
                            {/*                        }*/}
                            {/*                    }}*/}
                            {/*                />*/}
                            {/*            </div>*/}
                            {/*        </HtmlTooltip>*/}
                            {/*    ):(*/}
                            {/*        <FormControl*/}
                            {/*            disabled={!!state.montoCuota}*/}
                            {/*            required*/}
                            {/*            fullWidth>*/}
                            {/*            <InputLabel htmlFor="tasaInteres">*/}
                            {/*                {Strings.tasaInteres} {!!state.ciclosPago && <SelectEnum value={ state.ciclosPago} group={"ciclosPago"} />}*/}
                            {/*            </InputLabel>*/}
                            {/*            <Input id="tasaInteres"*/}
                            {/*                   name="tasaInteres"*/}
                            {/*                   value={state.tasaInteres??""}*/}
                            {/*                   type="number"*/}
                            {/*                   inputProps={{step:"any",inputMode:"decimal"}}*/}
                            {/*                   onChange={handleChange}*/}
                            {/*                   startAdornment={<InputAdornment position="start">%</InputAdornment>}*/}
                            {/*                   endAdornment={*/}
                            {/*                       <InputAdornment position="end">*/}
                            {/*                           <IconButton  color={"primary"} onClick={(e)=>setCalcularPorMenu(e.currentTarget)} size="small">*/}
                            {/*                               <ArrowDropDown />*/}
                            {/*                           </IconButton>*/}
                            {/*                       </InputAdornment>*/}
                            {/*                   }*/}
                            {/*            />*/}
                            {/*        </FormControl>*/}
                            {/*    )}*/}

                            {/*    <Menu anchorEl={calcularPorMenu} open={Boolean(calcularPorMenu)} onClose={()=>setCalcularPorMenu(null)}>*/}
                            {/*            <MenuItem disabled={true}>Calcular por</MenuItem>*/}
                            {/*            <MenuItem onClick={()=> handleCalcularPor("interes")} >*/}
                            {/*                <ListItemIcon>*/}
                            {/*                    {calcularPor === "interes" ? (*/}
                            {/*                        <CheckBoxOutlined fontSize="small" />*/}
                            {/*                    ):(*/}
                            {/*                        <CheckBoxOutlineBlankOutlined fontSize="small" />*/}
                            {/*                    )}*/}
                            {/*                </ListItemIcon>*/}
                            {/*                <ListItemText>{Strings.interes}</ListItemText>*/}
                            {/*            </MenuItem>*/}
                            {/*            <MenuItem onClick={()=> handleCalcularPor("montoCuota")} >*/}
                            {/*                <ListItemIcon>*/}
                            {/*                    {calcularPor === "montoCuota" ? (*/}
                            {/*                        <CheckBoxOutlined fontSize="small" />*/}
                            {/*                    ):(*/}
                            {/*                        <CheckBoxOutlineBlankOutlined fontSize="small" />*/}
                            {/*                    )}*/}
                            {/*                </ListItemIcon>*/}
                            {/*                <ListItemText>{Strings.monto+" "+Strings.cuotas}</ListItemText>*/}
                            {/*            </MenuItem>*/}
                            {/*    </Menu>*/}
                            {/*</Grid>*/}


                            <Grid item xs={6} sm={4} md={4} lg={3}>
                                <FormControl
                                    disabled={!!state.montoCuota}
                                    required={!state.montoCuota}
                                    fullWidth>
                                    <InputLabel htmlFor="tasaInteres">
                                        {Strings.tasaInteres} {!!state.ciclosPago && <SelectEnum value={ state.ciclosPago} group={"ciclosPago"} />}
                                    </InputLabel>
                                    <Input id="tasaInteres"
                                           name="tasaInteres"
                                           value={state.tasaInteres??""}
                                           type="number"
                                           inputProps={{step:"any",inputMode:"decimal"}}
                                           onChange={handleChange}
                                           startAdornment={<InputAdornment position="start">%</InputAdornment>}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={4} md={4} lg={3}>
                                <HtmlTooltip title={
                                    <em> {Strings.interesDesconocidoMsj}</em>
                                } disableHoverListener>
                                    <div>
                                        <TextFieldCurrency
                                            name="montoCuota"
                                            value={state.montoCuota??""}
                                            onChange={handleChange}
                                            fullWidth
                                            placeholder={"Opcional"}
                                            label={Strings.monto+" "+Strings.cuotas}
                                            InputProps={(state.montoCuota && state.plazo && state.capitalInicial && state.tipoAmortizacion) ? {
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <HtmlTooltip title={"Calcular tasa de interés."}>
                                                            <IconButton disabled={fetchingTasa} color={"primary"} onClick={getTasaInteres} size="large">
                                                                {fetchingTasa?<CircularProgress size={20} color="inherit"/>:<CalculateOutlined/>}
                                                            </IconButton>
                                                        </HtmlTooltip>
                                                    </InputAdornment>
                                                ),
                                            }:{}}
                                        />
                                    </div>
                                </HtmlTooltip>
                            </Grid>




                            <Grid item xs={6} sm={4} md={4} lg={3}>
                                <DateInput
                                    name={"fecha"}
                                    value={state.fecha}
                                    label={Strings.fecha}
                                    //quincenalFijo={state.ciclosPago === "16"}
                                    required
                                    onChange={handleChange}
                                    fullWidth native={undefined} clearable={undefined} openTo={undefined} views={undefined}
                                    quincenalFijo={undefined}                            />
                            </Grid>
                            <Grid item xs={6} sm={4} md={4} lg={3}>
                                <DateInput
                                    name="fechaPrimerPago"
                                    value={state.fechaPrimerPago}
                                    label={Strings.fecha + " " + Strings.primerPago}
                                    quincenalFijo={state.ciclosPago?.toString() === "16"}
                                    onChange={handleChange}
                                    min={state.fecha}
                                    required
                                    fullWidth native={undefined} clearable={undefined} openTo={undefined} views={undefined}
                                />
                            </Grid>
                            {!!state.id &&
                                <Grid item xs={6} sm={4} md={3}>
                                    <DateInput
                                        name="fechaProximoPago"
                                        value={state.fechaProximoPago}
                                        label={Strings.fecha + " " + Strings.proximo + " " + Strings.pago}
                                        quincenalFijo={state.ciclosPago === 16}
                                        onChange={handleChange}
                                        fullWidth native={undefined} clearable={undefined} openTo={undefined} views={undefined}                            />
                                </Grid>
                            }
                        </Grid>
                    </div>
                    <div className={"customCard"}>
                        <Typography color={"primary"} className={"title"}>OTROS</Typography>
                        <Grid container spacing={3}>
                            {state.ciclosPago?.toString() === "1" &&
                                <Grid item xs={12}  sm={4} lg={3}>
                                    <SelectDay
                                        name={"diasExcluidos"}
                                        value={state.diasExcluidos}
                                        onChange={({target})=>setState({...state,diasExcluidos: target.value})}
                                    />
                                </Grid>
                            }
                            {!Boolean(state.id) &&
                                <Grid item xs={12} sm={4} md={3}>
                                    <SelectCaja
                                        name="cajaId"
                                        label={Strings.caja}
                                        value={state.cajaId}
                                        onChange={handleChange}
                                    />
                                </Grid>
                            }
                            <Grid item xs={6} sm={4} md={3} lg={2}>
                                <TextField
                                    name="referencia"
                                    label={Strings.codigoRef}
                                    value={state.referencia}
                                    fullWidth
                                    onChange={handleChange}
                                    inputProps={{maxLength: 20}}
                                />
                            </Grid>
                            <Grid item xs={6} sm={4} md={2}>
                                <TextFieldCurrency
                                    name="gastosLegales"
                                    label={Strings.gastosLegales}
                                    value={state.gastosLegales??""}
                                    fullWidth
                                    disabled={Boolean(state.id)}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={6} sm={4} md={3} lg={2}>
                                <TextField
                                    name="porcientoMora"
                                    type="number"
                                    inputProps={{step:"any",inputMode:"decimal"}}
                                    label={Strings.mora}
                                    value={state.porcientoMora??""}
                                    fullWidth
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">%</InputAdornment>,
                                    }}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={6} sm={4} md={3}>
                                <TextField
                                    name="porcientoComision"
                                    label={Strings.comision}
                                    type={"number"}
                                    inputProps={{
                                        max:100,
                                        step:"any",
                                        inputMode:"decimal"
                                    }}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">%</InputAdornment>,
                                    }}
                                    value={state.porcientoComision??""}
                                    fullWidth
                                    onChange={handleChange}
                                />
                            </Grid>

                            {!!state.porcientoComision &&
                                <Grid item xs={12} sm={4} md={3}>
                                    <SelectAgente
                                        name="usuarioIdAgente"
                                        label={Strings.agenteAcomisionar}
                                         value={state.usuarioIdAgente}
                                        onChange={handleChange}
                                    />
                                </Grid>
                            }
                            <Grid item xs={12} sm={4} lg={3}>
                                <SelectCartera value={state.carteraId}
                                               name={"carteraId"}
                                               label={Strings.cartera}
                                               onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={6} sm={4} md={3}>
                                <TextFieldCurrency
                                    name="montoSeguro"
                                    label={Strings.monto +" "+Strings.seguro}
                                    value={state.montoSeguro??""}
                                    onChange={handleChange}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={6} sm={4} md={3}>
                                <TextFieldCurrency
                                    name="inicial"
                                    disabled={Boolean(state.id)}
                                    label={Strings.inicial}
                                    value={state.inicial??""}
                                    onChange={handleChange}
                                    fullWidth
                                />
                            </Grid>


                            {customFormInput && Object.keys(customFormInput).map((key)=>
                                <Grid item xs={12} sm={4} lg={2} key={key}>

                                    {!!(customFormInput)[key].source?(
                                        <SelectUsoMultiples
                                            emptyOption={{key:0,value:Strings.ninguna}}
                                            group={customFormInput[key].source ?? ""}
                                            name={"campo"+key.slice(-1)}
                                            label={customFormInput[key].name ?? ""}
                                            required={customFormInput[key].isRequired}
                                            value={(state as any)["campo"+key.slice(-1)] ? (state as any)["campo"+key.slice(-1)] : undefined}
                                            onChange={handleChange}
                                            // inputProps={{maxLength: 50}}
                                        />

                                    ):(
                                        <TextField
                                            name={"campo"+key.slice(-1)}
                                            label={customFormInput[key].name}
                                            required={customFormInput[key].isRequired}
                                            value={(state as any)["campo"+key.slice(-1)] ? (state as any)["campo"+key.slice(-1)] : ""}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 50}}
                                            fullWidth
                                        />
                                    )}

                                </Grid>
                            )}



                            {/*{customFormInput && Object.keys(customFormInput).map((key)=>*/}
                            {/*    <Grid item xs={12} sm={4} lg={2} key={key}>*/}
                            {/*        <TextField*/}
                            {/*            name={key}*/}
                            {/*            label={customFormInput[key].name}*/}
                            {/*            required={customFormInput[key].isRequired}*/}
                            {/*            value={state[key] ? state[key] : ""}*/}
                            {/*            onChange={handleChange}*/}
                            {/*            inputProps={{maxLength: 50}}*/}
                            {/*            fullWidth*/}
                            {/*        />*/}
                            {/*    </Grid>*/}
                            {/*)}*/}
                        </Grid>
                    </div>
                    <div className={"customCard"}>
                        <Typography color={"primary"} className={"title"}>{Strings.codeudor.toUpperCase()}</Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    name="codeudor"
                                    label={Strings.primerNombre}
                                    value={state.codeudor}
                                    fullWidth
                                    onChange={handleChange}
                                    inputProps={{maxLength: 100}}
                                    required={Boolean(state.codeudorCedula || state.codeudorTelefono || state.codeudorDireccion)}
                                />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <TextField
                                    name="codeudorCedula"
                                    label={Strings.cedula}
                                    value={state.codeudorCedula} //no trae el parametro en actualizar
                                    fullWidth
                                    onChange={handleChange}
                                    inputProps={{maxLength: 20}}
                                />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <TextFieldPhone
                                    name="codeudorTelefono"
                                    label={Strings.telefono}
                                    value={state.codeudorTelefono} //no trae el parametro en actualizar
                                    fullWidth
                                    onChange={handleChange}
                                    inputProps={{maxLength: 20}}
                                />
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <TextField
                                    name="codeudorDireccion"
                                    label={Strings.direccion}
                                    value={state.codeudorDireccion}
                                    fullWidth
                                    onChange={handleChange}
                                    inputProps={{maxLength: 100}}
                                />
                            </Grid>
                        </Grid>
                    </div>
                </form>

                <Box className={"formControl"}>

                    <Button type={"button"} sx={{mr:"auto"}} onClick={()=>navigate(location.pathname,{state:{showCal:true}})} variant={"outlined"} disabled={status==="loading"} startIcon={<AssessmentOutlined/>} size={"small"}>
                        {Strings.amortizacion}</Button>

                    <Button type={"button"} sx={{mr:0.5}} color={"error"} onClick={()=>navigate(-1)} variant={"outlined"} disabled={status==="loading"} startIcon={<Close/>} size={"small"}>{Strings.cancelar}</Button>
                    <Button type={"submit"}  form={"form1"} variant={"outlined"} disabled={status==="loading"}  startIcon={<Save/>} size={"small"}>
                        {status === "loading"? (
                            <span><CircularProgress size={14} color="inherit" /> &nbsp; {Strings.cargando}</span>
                        ):(
                            <span>{Strings.guardar}</span>
                        )}
                    </Button>
                </Box>

                {urlState && urlState.showCal &&
                <AmortCal onClose={()=>navigate(-1)}
                          inicialState={{
                              fechaPrimerPago: state.fechaPrimerPago,
                              monto: state.capitalInicial,
                              tasa: state.tasaInteres,
                              cuotas: state.plazo,
                              cicloPago:state.ciclosPago,
                              tipoAmortizacion:state.tipoAmortizacion,
                              montoCuota:state.montoCuota,
                              comision:state.porcientoComision,
                              montoSeguro:state.montoSeguro
                          }}
                          onUseVal={(val:any)=>{
                              setState(prevState => ({
                                  ...prevState,
                                  fechaPrimerPago: val.fechaPrimerPago,
                                  capitalInicial: val.monto,
                                  tasaInteres: val.tasa,
                                  plazo: val.cuotas,
                                  ciclosPago: val.cicloPago,
                                  tipoAmortizacion: val.tipoAmortizacion,
                                  montoCuota: val.montoCuota,
                                  porcientoComision:val.comision,
                                  montoSeguro:val.montoSeguro
                              }))
                          }} />
                }
            </div>
        </>
    );
}

